import(/* webpackMode: "eager" */ "/app/src/app/(auth)/error.tsx");
